import { createReportFreeVariation } from '../../../../shared/mixpanel/events/createReportFreeVariation';

export { reportAddToFavorites } from './reportAddToFavorites';
export { reportRemoveFromFavorites } from './reportRemoveFromFavorites';
export { reportSellerAvatarClicked } from './reportSellerAvatarClicked';
export { reportPageView } from './reportPageView';
export { reportCustomizeOnDesktop } from './reportCustomizeOnDesktop';

export const reportFreeVariation =
    createReportFreeVariation('Choose Variation');
